import { __exports as e } from "../../../../../../../../../_virtual/default.js";
var t;
function l() {
  if (t) return e;
  t = 1, Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.DEFAULT_CONFIG = void 0;
  var r = ["ic-attribute", "ic-block", "ic-marker", "ic-mention"], a = {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allowfullscreen", "frameborder", "target"],
    CUSTOM_ELEMENT_HANDLING: {
      tagNameCheck: function(i) {
        return r.includes(i);
      },
      attributeNameCheck: /^(data-|contenteditable)/,
      allowCustomizedBuiltInElements: !1
    }
  };
  return e.DEFAULT_CONFIG = a, e;
}
export {
  l as __require
};
